export const IDLE_MODAL_STYLES = `
        .idle-modal-container {
          position: fixed;
          inset: 0;
          z-index: 9999;
        }

        .idle-modal-backdrop {
          position: absolute;
          inset: 0;
          background: var(--background-overlay);
          backdrop-filter: blur(1px);
          transition: opacity 200ms ease-out;
        }

        @media (prefers-reduced-motion: reduce) {
          .idle-modal-backdrop {
            transition: none;
          }
        }

        /* Centered positioning on all screen sizes */
        .idle-modal-positioner {
          position: absolute;
          inset: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 1rem;
        }

        .idle-modal-content {
          background: var(--background-primary);
          color: var(--contrast-primary);
          width: 100%;
          border-radius: 0;
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
          padding: 1rem;
          padding-bottom: calc(1rem + env(safe-area-inset-bottom));
          padding-top: calc(1rem + env(safe-area-inset-top));
          transform: translateY(0);
          animation: slideUp 200ms ease-out;
          position: relative;
        }
        @media (min-width: 640px) {
          .idle-modal-content {
            padding: 1.5rem;
            padding-bottom: calc(1.5rem + env(safe-area-inset-bottom));
            padding-top: calc(1.5rem + env(safe-area-inset-top));
            animation: fadeInScale 180ms ease-out;
            max-height: 90vh;
            overflow-y: auto;
          }
        }

        /* Dark mode support */
        @media (prefers-color-scheme: dark) {
          .idle-modal-content {
            background: var(--background-primary);
            color: var(--contrast-primary);
          }
        }

        /* Reduced motion support */
        @media (prefers-reduced-motion: reduce) {
          .idle-modal-content {
            animation: none;
          }
        }

        /* Animations */
        @keyframes slideUp {
          from {
            transform: translateY(12%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }

        @keyframes fadeInScale {
          from {
            transform: scale(0.98);
            opacity: 0;
          }
          to {
            transform: scale(1);
            opacity: 1;
          }
        }

        /* Header */
        .idle-modal-header {
          display: flex;
          align-items: center;
          gap: 1rem;
          margin-bottom: 1.5rem;
        }

        .idle-modal-icon {
          width: 48px;
          height: 48px;
          border-radius: 0;
          background: var(--background-tertiary);
          display: flex;
          align-items: center;
          justify-content: center;
          color: var(--contrast-secondary);
          flex-shrink: 0;
        }

        .idle-modal-title-section {
          flex: 1;
        }

        .idle-modal-title {
          font-size: 1.125rem;
          font-weight: 600;
          line-height: 1.4;
          margin: 0 0 0.25rem 0;
          color: inherit;
        }

        @media (min-width: 640px) {
          .idle-modal-title {
            font-size: 1.25rem;
          }
        }

        .idle-modal-subtitle {
          font-size: 0.875rem;
          color: var(--contrast-secondary);
          margin: 0;
          line-height: 1.4;
        }

        /* Body */
        .idle-modal-body {
          margin-bottom: 1.5rem;
        }

        .idle-modal-description {
          font-size: 0.875rem;
          line-height: 1.5;
          margin: 0 0 1rem 0;
          color: inherit;
        }

        @media (min-width: 640px) {
          .idle-modal-description {
            font-size: 1rem;
          }
        }

        .idle-countdown-container {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          padding: 1rem;
          background: var(--background-tertiary);
          border-radius: 0;
          border: 1px solid var(--border-color);
        }

        .idle-countdown-icon {
          color: var(--contrast-secondary);
          flex-shrink: 0;
        }

        .idle-countdown-text-section {
          flex: 1;
        }

        .idle-countdown-label {
          font-size: 0.75rem;
          font-weight: 500;
          color: var(--contrast-secondary);
          text-transform: uppercase;
          letter-spacing: 0.05em;
          margin-bottom: 0.25rem;
        }

        .idle-countdown-value {
          font-size: 1.125rem;
          font-weight: 600;
          color: var(--contrast-primary);
        }

        .idle-countdown-text {
          color: var(--warning-color);
          font-weight: 700;
        }

        /* Actions */
        .idle-modal-actions {
          display: flex;
          flex-direction: column;
          gap: 0.75rem;
        }

        @media (min-width: 640px) {
          .idle-modal-actions {
            flex-direction: row;
            justify-content: flex-end;
            gap: 0.75rem;
          }
        }

        .idle-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.5rem;
          padding: 0.75rem 1rem;
          border-radius: 0;
          font-size: 0.875rem;
          font-weight: 500;
          line-height: 1.25;
          border: 1px solid transparent;
          cursor: pointer;
          transition: all 150ms ease-out;
          min-height: 44px; /* Minimum touch target size */
          text-decoration: none;
        }

        @media (prefers-reduced-motion: reduce) {
          .idle-btn {
            transition: none;
          }
        }

        .idle-btn:focus {
          outline: 2px solid var(--info-color);
          outline-offset: 2px;
        }

        .idle-btn-secondary {
          background: var(--background-secondary);
          color: var(--contrast-secondary);
          border-color: var(--border-color);
        }

        .idle-btn-secondary:hover {
          background: var(--background-tertiary);
          border-color: var(--border-dark);
        }

        .idle-btn-primary {
          background: var(--primary-color);
          color: var(--text-inverse);
          border-color: var(--primary-color);
        }

        .idle-btn-primary:hover {
          background: var(--primary-hover);
          border-color: var(--primary-hover);
        }

        /* Ensure minimum height for landscape mobile */
        @media (max-height: 500px) and (orientation: landscape) {
          .idle-modal-content {
            min-height: min(40vh, 280px);
          }
        }
      `;
